import React from 'react';
import { createRoot } from 'react-dom/client';
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import App from './components/App';
import reducer from './reducers';
import { fetchMaterials, changeUILanguane, clientCofigurationUpdated } from './actions/index';
import { loadPlan, setSellerId,  } from './actions/plan'
import { setResellerId } from './actions/tsPlan'
import { crashReporter, googleAnalyticsMiddleWare } from './helpers/googleAnalytcisMiddleWare.js';
import actionEventMiddleWare from './helpers/actionEventMiddleWare.js';
import findGetParameter from './helpers/getParameterParser';
import createLogger from 'redux-logger';
import Raven from 'raven-js';
import { clientConfigurations } from './config.js';
import { isTurnstileRavenEvent } from './helpers/turnstileErrorFilter';

let middleWares = [/*createLogger,*/ thunkMiddleware, actionEventMiddleWare, crashReporter ];
if (process.env.NODE_ENV === 'production') {
    Raven.config('https://62d21df77b7a4995844106db40074be4@sentry.io/1355880', {
        shouldSendCallback: data => !isTurnstileRavenEvent(data)
    }).install();
    middleWares.push(googleAnalyticsMiddleWare);
}
else {
    middleWares.push(createLogger);

}

const store = createStore(reducer,
    applyMiddleware(
        ...middleWares
    ));


let getDataAttributeLang = () => {
    let root = document.getElementById("root");
    if (root) {
        return root.getAttribute("data-lang");
    }  
}


let locale = findGetParameter("lang") || getDataAttributeLang() || navigator.language || navigator.userLanguage || "fi";

store.dispatch(changeUILanguane(locale.substring(0,2)));
//changeUILanguane(findGetParameter("lang") || "fi");
let isGoogleTranslate = window.location.href.includes("translate.goog");
if (!isGoogleTranslate) {
    const container = document.getElementById('root');
    const root = createRoot(container);
    root.render(
        <Provider store={store}>
            <App />
        </Provider>,
       
    );
}
else {
    document.getElementById('root').innerHTML="<h1>This tool does not support Google translate. In order to use this tool please reopen this page without using it, or send your offerrequest to info@sunsauna.fi.</h1>"
}

let planId = findGetParameter("planId");
let resellerId = findGetParameter("resellerId");
if (planId) {
    store.dispatch(loadPlan(planId, findGetParameter("securityToken")));
}
else if (resellerId)
{
    store.dispatch(fetchMaterials());
    store.dispatch(setResellerId(resellerId));
}
else {
    store.dispatch(fetchMaterials());
    let slideConfigurationName = findGetParameter("priorityConfig") ||   findGetParameter("slideConfig") || "default"
    let configuration = clientConfigurations[slideConfigurationName] || clientConfigurations["default"];
    store.dispatch(clientCofigurationUpdated(configuration));
}
let sellerID = findGetParameter("sellerid");
store.dispatch(setSellerId(sellerID));

